import styled from "@emotion/styled";
import { baseWidths, colors, footer, header, headerData } from "src/theme";
import { mediaQuery } from "src/common";

const ContentStyle = styled.div<{ expanded: boolean | null }>(({ expanded }) => ({
  position: 'relative',
  paddingTop: `${header.mobileHeight + headerData(expanded).mobileHeight}px`,
  backgroundColor: colors.background6,
  minHeight: `calc(100vh - ${footer.mobileHeight}px)`,

  [mediaQuery('mobile')]: {
    paddingTop: `${header.height + headerData(expanded).height}px`,
    minHeight: `calc(100vh - ${footer.height}px)`,
  },

  [mediaQuery('laptopL')]: {
    paddingTop: `${header.height + headerData(expanded).height}px`,
  },
  transition: 'height 0.3s ease, padding-top 0.3s ease',
}))

const ContainerStyle = styled.div({
  width: '90%',
  margin: '0 auto',
  paddingBlock: '40px',
  paddingTop: 0,

  [mediaQuery('mobile')]: {
    width: `${baseWidths.mobile}px`
  },
})

export const ContainerComponent = styled.div({
  display: 'flex',
  gap: 24,
  minHeight: '60vh',
  flexDirection: 'column',
  margin: '0 auto',
})

interface ContentProps {
  children: React.JSX.Element | React.JSX.Element[];
  expanded: boolean | null;
}

export const Content = ({ children, expanded }: ContentProps) =>
  <ContentStyle expanded={expanded}>
    <ContainerStyle>
      {children}
    </ContainerStyle>
  </ContentStyle>;
